import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PromoCodeFormComponent from '@websky/core/src/PromoCode/Form/PromoCodeForm';
import { PromoCodeFieldType } from '@websky/core/src/PromoCode/types';
const PromoCodeForm = props => {
    const { t } = useTranslation('PromoCode');
    const [hasAdditionalFields, setHasAdditionalFields] = useState(false);
    const availablePromoCodes = [/^РОСТЕХ$/i];
    const additionalFields = hasAdditionalFields
        ? [
            {
                name: 'confirm',
                type: PromoCodeFieldType.Checkbox,
                label: t('I confirm that I am an employee of Rostech. Otherwise, the Carrier has the right to cancel the ticket.'),
                validate: (value) => {
                    if (!value) {
                        return t('Required');
                    }
                    return undefined;
                }
            }
        ]
        : [];
    const onChangePromoCode = (value) => {
        setHasAdditionalFields(availablePromoCodes.some(regex => regex.test(value)));
    };
    return (React.createElement(PromoCodeFormComponent, Object.assign({}, props, { additionalFields: additionalFields, onChangePromoCode: onChangePromoCode })));
};
export default PromoCodeForm;
